import { ControlledList, DataGridLayout } from 'framework/list';
import { BadgeField, FullDateField, TextField, useFieldHelper } from 'framework/ui/field';
import DocuSignSignerStatusBadge from './badge/DocuSignSignerStatusBadge';

const DocuSignRecipientsBox = ({ source }: { source: string }) => {
  const { getValue } = useFieldHelper({ source });
  const signers = (getValue() || {}) as any[];

  return (
    <ControlledList data={{ items: signers, totalElements: signers.length, totalPages: 1 }}>
      <DataGridLayout showTotal={false} isSmallTable>
        <TextField source="name" label="Name" width="20%" />
        <TextField source="email" label="Email" width="20%" />
        <BadgeField badges={[<DocuSignSignerStatusBadge source="status" />]} label="Status" width="20%" />
        <FullDateField source="updatedAt" label="Updated at" width="30%" />
      </DataGridLayout>
    </ControlledList>
  );
};

export default DocuSignRecipientsBox;
